import styled from 'styled-components';
import { DEVICES } from '../../../config/appConfig';

export const StyleInsideHeader = styled.div`
  position: relative;
  min-height: 550px;
  background-color: black;
  background-size: cover;
  background-position: 100%;
  @media ${DEVICES.tablet} {
    min-height: 600px;
  }
  @media ${DEVICES.mobile} {
    min-height: 550px;
  }
  @media ${DEVICES.sMobile} {
    min-height: 500px;
  }
  @media ${DEVICES.sSMobile} {
    min-height: 500px;
  }
  .header-overlap-section {
    background-color: black;
    opacity: 1;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const HeroSectionContent = styled.div`
  position: absolute;
  bottom: 20%;
  left: 50%;
  transform: translateX(-50%);
  @media ${DEVICES.tablet} {
    bottom: 30%;
  }
  @media ${DEVICES.mobile} {
    bottom: 30%;
  }
  @media ${DEVICES.sMobile} {
    bottom: 32%;
  }
  @media ${DEVICES.sSMobile} {
    bottom: 30%;
  }
`;

export const HeroContent = styled.div`
  width: calc(100% - 55%);
  .chipsStyle {
    padding: 8px 18px;
    border: 1px solid #f58220;
    border-radius: 30px;
    width: fit-content;
    color: #f58220;
    font-size: 16px;
  }
  .headerStyle {
    font-size: 36px;
    font-weight: 600;
    display: block;
    color: #fff;
  }
  .headerStyle2 {
    font-size: 36px;
    font-weight: 600;
    color: #fff;
  }
  .highlightHeaderStyle {
    font-size: 36px;
    font-weight: 600;
    color: #f58220;
  }
  .ParaHeaderStyle {
    font-size: 14px;
    font-weight: 400;
    display: inline-block;
    color: #fff;
    padding-top: 12px;
  }
  @media ${DEVICES.tablet} {
    width: calc(100% - 10%);
    .headerStyle {
      font-size: 34px;
    }
    .headerStyle2 {
      font-size: 34px;
    }
    .highlightHeaderStyle {
      font-size: 34px;
    }
    .ParaHeaderStyle {
      font-size: 16px;
      padding-top: 8px;
    }
  }
  @media ${DEVICES.mobile} {
    width: calc(100% - 10%);
    .chipsStyle {
      font-size: 12px;
      margin-bottom: 8px;
    }
    .headerStyle {
      font-size: 30px;
    }
    .headerStyle2 {
      font-size: 30px;
    }
    .highlightHeaderStyle {
      font-size: 30px;
    }
    .ParaHeaderStyle {
      font-size: 14px;
    }
  }
  @media ${DEVICES.sMobile} {
    .chipsStyle {
      padding: 6px 12px;
      font-size: 12px;
      margin-bottom: 8px;
    }
    .headerStyle {
      font-size: 24px;
    }
    .headerStyle2 {
      font-size: 24px;
    }
    .highlightHeaderStyle {
      font-size: 24px;
    }
    .ParaHeaderStyle {
      font-size: 12px;
    }
  }
  @media ${DEVICES.sSMobile} {
    .chipsStyle {
      padding: 6px 12px;
      font-size: 10px;
      margin-bottom: 4px;
    }
    .headerStyle {
      font-size: 20px;
    }
    .headerStyle2 {
      font-size: 20px;
    }
    .highlightHeaderStyle {
      font-size: 20px;
    }
    .ParaHeaderStyle {
      font-size: 10px;
    }
  }
`;
